export default [
  {
    selected_api: 'GoogleMailV2API',
    type_of: 'write',
    action: 'message',
    hide_fields: {
      cc: true,
      bcc: true,
      reply_to: true,
      file: true,
      label_ids: true,
      from_name: true,
      from: true,
    },
  },
  {
    selected_api: 'ZapierMailAPI',
    type_of: 'write',
    action: 'outbound',
    hide_fields: {
      from_name: true,
      reply_to: true,
      cc: true,
      bcc: true,
      file: true,
    },
  },
  {
    selected_api: 'MailchimpCLIAPI',
    type_of: 'write',
    action: 'outbound',
    hide_fields: {
      replace_interests: true,
      groups: true,
      language: true,
    },
  },
  {
    selected_api: 'TrelloAPI',
    type_of: 'write',
    action: 'card',
    hide_fields: {
      due: true,
      checklist_name: true,
      url: true,
      custom_labels: true,
      member: true,
      file: true,
    },
  },
  {
    selected_api: 'SlackAPI',
    type_of: 'write',
    action: 'channel_message',
    hide_fields: {
      icon: true,
      image_url: true,
      file: true,
      thread_ts: true,
      link_names: true,
      unfurl: true,
    },
  },
  {
    selected_api: 'WebHookAPI',
    type_of: 'write',
    action: 'post',
    hide_fields: {
      unflatten: true,
      wrap_in_array: true,
      file: true,
      auth: true,
    },
  },
  {
    selected_api: 'GoogleCalendarAPI',
    type_of: 'write',
    action: 'detailed_event',
    hide_fields: {
      location: true,
      colorId: true,
      guestsCanModify: true,
      transparency: true,
      attendees: true,
      reminders_minutes: true,
      reminders_methods: true,
      recurrence_frequency: true,
      recurrence_count: true,
      recurrence_until: true,
      all_day: true,
      visibility: true,
      reminders__useDefault: true,
    },
  },
];
